import { css } from '@emotion/core';

export const cursor = (props) =>
  props.cursor
    ? css`
        cursor: ${props.cursor};
      `
    : null;
